import React, { lazy } from 'react';
import { RouteConfig } from 'react-router-config';
import IconException from '@/assets/images/menu/icon-exception.react.svg?react';
import { isAndroid, isApple } from '@/infrastructure/product-info';
import { MenuIcon } from '@/presentation/components/menu-icon';

export const diskRoutes = (): RouteConfig[] => {
  if (!isAndroid() && !isApple()) {
    return [];
  }
  return [
    {
      path: '/disk-monitor',
      name: '磁盘',
      icon: <MenuIcon icon={IconException} />,
      routes: [
        {
          path: '/disk-monitor/analytics',
          name: '指标分析',
          component: lazy(() => import('@/presentation/pages/disk/analytics')),
        },
        {
          // TODO(disk-monitor): 快照设计稿为 Android（internal/ external/ 是 Android 概念），本期只放 Android
          path: '/disk-monitor/snapshot',
          name: '快照分析',
          component: lazy(() => import('@/presentation/pages/disk/snapshot')),
        },
      ],
    },
  ];
};
